<div class="search" [ngClass]="{ disabled: isSearchingMyLocation() }">
  <mat-form-field class="search__input" subscriptSizing="dynamic">
    <input
      matInput
      [attr.matInputAutofocus]="disabled() ? null : ''"
      type="text"
      placeholder="{{ 'searchAddress.searchPlaceholder' | translate }}"
      [formControl]="addressCtrl"
      [matAutocomplete]="auto"
      [attr.disabled]="disabled()"
    />
    @if (isSearchingAddress()) {
      <mat-spinner matSuffix [diameter]="20" style="margin-right: 16px" />
    } @else if (hasAddress()) {
      <button matSuffix mat-icon-button (click)="clearAddress()" matTooltip="Clear address">
        <mat-icon fontSet="material-symbols-rounded">close</mat-icon>
      </button>
    }
    <mat-autocomplete
      #auto="matAutocomplete"
      autoActiveFirstOption
      (optionSelected)="optionSelected($event)"
    >
      @for (item of addressOptions(); track item.formatted_address) {
        <mat-option [value]="item">{{ item.formatted_address }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <button
    class="button-icon"
    mat-button
    matTooltip="{{ 'searchAddress.useCurrentLocation' | translate }}"
    (click)="getCurrentLocation()"
  >
    @if (isSearchingMyLocation()) {
      <mat-spinner diameter="20" />
    } @else {
      <mat-icon fontSet="material-symbols-rounded">my_location</mat-icon>
    }
  </button>
</div>
